import { ReactElement } from 'react';
import { SuccessModalIcon } from '../../../assets/Icon';
import Modal from '../../common/modal/Modal';
import styles from './style.module.scss';

type TransactionSuccessModalProps = {
  open: boolean;
  onClose: () => void;
  title: string;
  isLoading?: boolean;
  titleClassName?: string;
  body?: React.ReactNode;
  isCloseIconVisible?: boolean;
};

const TransactionSuccessModal = ({
  onClose,
  open,
  title,
  body,
  titleClassName,
  isCloseIconVisible = true,
}: TransactionSuccessModalProps) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      isCloseIconVisible={isCloseIconVisible}>
      <div className={styles.wrapper}>
        <SuccessModalIcon />
        <p className={`${styles.title} ${titleClassName}`}>{title}</p>
        <div className={styles.txnInformation}>{body}</div>
      </div>
    </Modal>
  );
};

export default TransactionSuccessModal;
